import { FiltersType } from "components/Shared/GlobalFilter/context/interfaces"
import {
	Interval,
	SinglePeriod,
} from "components/Shared/PhronesisCalendar/PhronesisCalendar.domain"
import { mapModuleFilters } from "../utils"
import { FieldFilters, validateFilters } from "./useValidateFilters"

export const useGetErrorFilters = (
	filters: FiltersType,
	calendarDates: Interval | SinglePeriod,
	restricted: Array<FieldFilters>
) => {
	const mappedFilters = mapModuleFilters({
		filters,
		calendarDates,
	})
	const errorFilters = validateFilters(mappedFilters, restricted)

	return !!errorFilters
}
